module.exports = __webpack_public_path__ + "img/ExcellenceInEducationBanner.af7f0924.jpg";